import { CircularProgress } from "@mui/material";
import cn from "classnames";
import "./loading_state.scss";

export const BrandLoadingState = ({ size, className }) => {
  return (
    <div className={cn("brand-loading-state", className)}>
      <CircularProgress size={size} />
    </div>
  );
};
